/* unplugin-vue-components disabled */import { render } from "./CenterTop.vue?vue&type=template&id=3241704a&scoped=true&ts=true"
import script from "./CenterTop.vue?vue&type=script&lang=ts"
export * from "./CenterTop.vue?vue&type=script&lang=ts"

import "./CenterTop.vue?vue&type=style&index=0&id=3241704a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3241704a"]])

export default __exports__